import { FacePlaceMiniBC, StatsCountMiniBC, TypePlaceMiniBC } from 'models/mini-bc-model';
import clickAudio from 'assets/images/audio/click.mp3';

const bcFunction = {
    bcFade: [
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'nai',
            odds: '1:0.96',
            order: 1,
            keyMoneyConfirm: 'moneyConfirmNai',
            keyTotalMoney: 'moneyCountNai',
        },
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'bau',
            odds: '1:0.96',
            order: 5,
            keyMoneyConfirm: 'moneyConfirmBau',
            keyTotalMoney: 'moneyCountBau',
        },
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'ga',
            odds: '1:0.96',
            order: 3,
            keyMoneyConfirm: 'moneyConfirmGa',
            keyTotalMoney: 'moneyCountGa',
        },
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'ca',
            odds: '1:0.96',
            order: 4,
            keyMoneyConfirm: 'moneyConfirmCa',
            keyTotalMoney: 'moneyCountCa',
        },
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'cua',
            odds: '1:0.96',
            order: 2,
            keyMoneyConfirm: 'moneyConfirmCua',
            keyTotalMoney: 'moneyCountCua',
        },
        {
            currentBet: 0,
            level1: 1.96,
            levelnum: 1,
            maxbet: 50000000,
            methodname: 'tom',
            odds: '1:0.96',
            order: 6,
            keyMoneyConfirm: 'moneyConfirmTom',
            keyTotalMoney: 'moneyCountTom',
        },
    ] as FacePlaceMiniBC[],
    effectChipBet: (
        htmlString: string,
        pageDom: HTMLElement,
        listChip: any[],
        placeEl: HTMLElement,
        typeBet: TypePlaceMiniBC,
        chipValue: number,
        scale: number
    ) => {
        let chipActiveEl = listChip.find((chipEl: HTMLButtonElement) => {
            return Number(chipEl.getAttribute('datatype')) === chipValue;
        });
        const cloneChip = document.createElement('div');
        const coordinatesChipActive = chipActiveEl.getBoundingClientRect();
        cloneChip.innerHTML = htmlString;
        cloneChip.style.position = 'absolute';
        cloneChip.style.top = coordinatesChipActive.top + 'px';
        cloneChip.style.left = coordinatesChipActive.left + 'px';
        cloneChip.style.width = coordinatesChipActive.width - 5 + 'px';
        cloneChip.style.height = coordinatesChipActive.height - 5 + 'px';
        cloneChip.style.zIndex = '1001';
        cloneChip.setAttribute('data-typebet', typeBet);
        cloneChip.classList.add('chipEmbed', 'wrap-chip');
        pageDom.appendChild(cloneChip);
        const coordinatesEl = placeEl.getBoundingClientRect();
        const getXYMove = bcFunction.randomPosiElRect(coordinatesEl, coordinatesChipActive.width * scale);
        
        cloneChip.style.transform = `scale(${scale})`;
        cloneChip.style.left = getXYMove.x + 'px';
        cloneChip.style.top = getXYMove.y + 'px';

        setTimeout(() => {
            let newY = getXYMove.y - coordinatesEl.top;
            let newX = getXYMove.x - coordinatesEl.left;

            if (newX < -12) newX = 0;
            else if (newX > coordinatesEl.width - 25) {
                newX = coordinatesEl.width - 50;
            }

            if (newY < -12) newY = -12;
            else if (newY > coordinatesEl.height) {
                newY = getXYMove.y - coordinatesEl.top - 25;
            }

            cloneChip.style.left = newX + 'px';
            cloneChip.style.top = newY + 'px';
            placeEl.appendChild(cloneChip);
        }, 310);
    },

    randomPosiElRect(coordinatesChipActive: DOMRect, wScale: number) {
        let xRandom = 0;
        let yRandom = 0;
        let maxRandomX = coordinatesChipActive.width;
        let maxRandomY = coordinatesChipActive.height;
        if (coordinatesChipActive.x > coordinatesChipActive.width) {
            maxRandomX = coordinatesChipActive.x + coordinatesChipActive.width;
        }
        if (coordinatesChipActive.y > coordinatesChipActive.height) {
            maxRandomY = coordinatesChipActive.y + coordinatesChipActive.height;
        }

        xRandom = this.getRandomInt(coordinatesChipActive.x, maxRandomX - wScale);
        yRandom = this.getRandomInt(coordinatesChipActive.y, maxRandomY - wScale);
        return {
            x: xRandom,
            y: yRandom,
        };
    },
    getRandomInt: (min: number, max: number) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    playClick: (el: HTMLAudioElement) => {
        el = new Audio(clickAudio);
        el.pause();
        el.currentTime = 0;
        el.play();
    },
    dealerSpeak: (el: HTMLAudioElement, url: string) => {
        el = new Audio(url);
        el.pause();
        el.currentTime = 0;
        el.volume = 0.5;
        el.play();
    },
    calcstatsTotal: (historyData: any[], statsCount: StatsCountMiniBC) => {
        historyData.forEach((item) => {
            //1: nai, 2: cua, 3: ga, 4: ca, 5:bau, 6:tom

            if (item.result.includes(1)) {
                // 1: nai
                statsCount.nai = (statsCount.nai || 0) + 1;
            }
            if (item.result.includes(2)) {
                // 2: cua
                statsCount.cua = (statsCount.cua || 0) + 1;
            }
            if (item.result.includes(3)) {
                // 3: ga
                statsCount.ga = (statsCount.ga || 0) + 1;
            }
            if (item.result.includes(4)) {
                //4: ca
                statsCount.ca = (statsCount.ca || 0) + 1;
            }
            if (item.result.includes(5)) {
                //5: bau
                statsCount.bau = (statsCount.bau || 0) + 1;
            }
            if (item.result.includes(6)) {
                //6: tom
                statsCount.tom = (statsCount.tom || 0) + 1;
            }
        });
        return statsCount;
    },
};

export const chatSuggestBC = [
    'quất mạnh tay bầu nào',
    'quất mạnh tay cua',
    'bể cầu rồi',
    'ngon, húp trọn!',
    'đu xỉu tiếp nào',
    'Nay đen vãi',
    'anh zai ơi, Ai kéo em vào bờ với',
    'Cầu đẹp zô thôi!',
    'Chào các em, Anh đi rút tiền đây^^',
    'Đánh gà ra cá :(',
    'Tôm ae ơi',
    'Yêu ad vl',
];

export default bcFunction;
